import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { CHECKOUT_URL } from '../../utils/checkout';
import { pricingRows, pricingTrustItems } from '../../data/pricing';
export function Pricing() {
  return <section id="oferta-base" className="bg-bg-primary py-10 sm:py-14" data-id="element-173" data-mp="3gijjanzpi1ed">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-174" data-mp="3gkmh3u73oytn">
        <SectionTag icon="💰" data-id="element-175" data-mp="3lhcvmd39bmcy">Oferta Especial</SectionTag>
        <h2 className="mt-4 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-176" data-mp="3pj7yvn4r09td">
          ¿Cuánto vale para ti recuperar tus domingos?
        </h2>
        <p className="mt-3 text-base text-muted sm:text-lg" data-id="element-177" data-mp="3ugrmver900yi">
          Acceso inmediato y garantía total de 14 días.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-md px-4 sm:px-6" data-id="element-178" data-mp="205cqif3qf39s">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="rounded-3xl border border-lime/30 bg-bg-secondary p-6 sm:p-7" data-id="element-179" data-mp="253mpz1whoq17">
          <p className="font-heading text-xs font-semibold uppercase tracking-wider text-muted" data-id="element-180" data-mp="16ip6qlxscwne">
            ⚽ MISTER PRO: La Pizarra del Entrenador
          </p>
          <p className="mt-1.5 text-xs text-muted" data-id="element-181" data-mp="xk4v24qn7n8o">6 tomos + 5 bonos, listos para llevar al campo.</p>

          <div className="mt-4 space-y-1.5" data-id="element-182" data-mp="1u8jg2tiwc32w">
            {pricingRows.map(row => <div key={row.content} className="flex items-center justify-between gap-3 border-b border-white/5 py-1.5 text-sm" data-id="element-183" data-mp="1pa9kiht9f0gr">
                <span className="text-white/80" data-id="element-184" data-mp="1ga3bp98iaonx">{row.content}</span>
                <span className="flex flex-shrink-0 items-center gap-2" data-id="element-185" data-mp="1g9jp3f7wvc3k">
                  {row.value !== '—' && <span className="text-muted" data-id="element-186" data-mp="9v2e6z3u1yf8">{row.value}</span>}
                  <CheckIcon size={14} className="text-success" data-id="element-187" data-mp="4tmr71i3hhu7" />
                </span>
              </div>)}
            <div className="flex items-center justify-between py-1.5 text-sm font-semibold text-white" data-id="element-188" data-mp="6ccyu0klsn83">
              <span data-id="element-189" data-mp="ba53lv6ck3tp">VALOR TOTAL</span>
              <span data-id="element-190" data-mp="3tgt75glr0ix9">119,40€</span>
            </div>
          </div>

          <p className="mt-4 text-xs font-medium text-muted" data-id="element-191" data-mp="3tg9kxnp2f8df">Precio hoy (84% de descuento):</p>
          <p className="font-heading text-5xl font-bold text-lime sm:text-6xl" data-id="element-192" data-mp="1axfqe1zkqsc">19€</p>
          <p className="mt-2 text-sm text-orange" data-id="element-193" data-mp="3jp59uz2ig7nv">⏰ Precio de lanzamiento — sube pronto</p>

          <div className="mt-6" data-id="element-194" data-mp="3oi8479f43l54">
            <a href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-2 rounded-xl bg-lime px-8 py-4 font-heading text-base font-semibold uppercase tracking-wide text-bg-primary transition-all duration-200 hover:bg-lime-hover active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-lime focus-visible:ring-offset-2 focus-visible:ring-offset-bg-primary sm:text-lg" data-id="element-195" data-mp="3ojj5n2l34gt2">
              Quiero MISTER PRO por 19€
            </a>
          </div>

          <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] text-muted" data-id="element-196" data-mp="2h6byrnj2tg3g">
            {pricingTrustItems.map(item => <span key={item.label} className="flex items-center gap-1" data-id="element-197" data-mp="2v769ictljt5a">
                <item.icon size={12} data-id="element-198" data-mp="2r36tdvc8awcg" /> {item.label}
              </span>)}
          </div>
        </m.div>
      </div>
    </section>;
}